import { render, staticRenderFns } from "./upload-btn.vue?vue&type=template&id=488b301c&scoped=true&"
import script from "./upload-btn.vue?vue&type=script&lang=js&"
export * from "./upload-btn.vue?vue&type=script&lang=js&"
import style0 from "./upload-btn.vue?vue&type=style&index=0&id=488b301c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b301c",
  null
  
)

export default component.exports